import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { NotesTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};
export const schemaLoanRequestResolver_GetNotes = NotesTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetNotes = z.infer<typeof schemaLoanRequestResolver_GetNotes>;

export type LoanRequestResolver_GetNotes = Resolver<Arguments, SchemaLoanRequestResolver_GetNotes>;
